import { testimonials } from '@/mocks/home';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3">妈妈们的口碑</h2>
          <p className="text-sm text-foreground-500">来自全国妈妈们的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-secondary-500"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.content}</p>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <div className="text-sm font-medium text-foreground-800">{t.name}</div>
                  <div className="text-xs text-foreground-400">{t.babyAge}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}